import type { KanbanLog } from './interfaces'

import { KanbanLogAction } from './enums'

interface KanbanLogReturn {
  getStage: (log: KanbanLog) => string | null
  isMainLog: (current: KanbanLog, index: number, logs: KanbanLog[]) => boolean
  isLastLog: (current: KanbanLog, index: number, logs: KanbanLog[]) => boolean
  getFieldLabel: (field: string | null) => string
  getActionLabel: (action: string) => string
}

const FIELD_LABELS: Record<string, string> = {
  status: 'change stage',
  stage: 'change stage',
  stage_deadline: 'change deadline',
  stage_details: 'change details',
  kanban_priority: 'change priority',
  agent_id: 'change agent',
  deadline: 'change deadline',
  team_owner: 'change Team owner',
  resolution: 'change resolution',
  waiting_reason: 'change waiting reason',
  customer_outcome: 'change customer outcome',
  cancel_reason: 'change cancel reason',
}

const ACTION_LABELS: Record<string, string> = {
  [KanbanLogAction.Created]: 'created',
  [KanbanLogAction.Updated]: 'updated',
  [KanbanLogAction.CommentAdded]: 'add comment',
  [KanbanLogAction.CommentEdited]: 'edit comment',
  [KanbanLogAction.CommentDeleted]: 'delete comment',
}

export const useKanbanLog = (): KanbanLogReturn => {
  const getStage = (log: KanbanLog): string | null => log.stage ?? log.task_status ?? null

  const isMainLog = (current: KanbanLog, index: number, logs: KanbanLog[]): boolean => {
    if (index === 0) return true
    const prev = logs[index - 1]
    return !prev || getStage(prev) !== getStage(current)
  }

  const isLastLog = (current: KanbanLog, index: number, logs: KanbanLog[]): boolean => {
    if (index >= logs.length - 1) return true
    const next = logs[index + 1]
    if (!next) return false
    return getStage(current) !== getStage(next)
  }

  const getFieldLabel = (field: string | null): string => {
    if (!field) return ''
    return FIELD_LABELS[field] ?? `change ${field.replace(/_/g, ' ')}`
  }

  const getActionLabel = (action: string): string => ACTION_LABELS[action] ?? action

  return {
    getStage,
    isMainLog,
    isLastLog,
    getFieldLabel,
    getActionLabel,
  }
}
